import bankFailureAnimation from "@/assets/bank-failure.json";
import PageTransition from "@/components/ui/PageTransition";
import { ArrowRightIcon, XIcon } from "lucide-react";
import Lottie from "react-lottie";
import { Button } from "./button/button";
import { getHelpCenterUrl } from "@/lib/utils";

export type ErrorPageProps = {
	title?: string;
	message?: string;
	submitText?: string;
	onClose: () => void;
	onSubmit?: () => void;
};

const ErrorPage = ({
	title = "Uh oh! Something went wrong.",
	message = "An unexpected error occurred.",
	submitText = "Contact Support",
	onClose,
	onSubmit,
}: ErrorPageProps) => {
	const lottieConfig = {
		loop: false,
		autoplay: true,
		animationData: bankFailureAnimation,
		rendererSettings: {
			preserveAspectRatio: "xMidYMid slice",
		},
	};

	return (
		<PageTransition className="h-full">
			<div className="max-w-xl mx-auto text-center">
				<button type="button" onClick={onClose}>
					<XIcon className="absolute right-4 top-4" role="button" />
				</button>
				<div className="">
					<div className="max-w-80 mx-auto">
						<Lottie options={lottieConfig} />
					</div>
				</div>
				<div>
					<div className="mt-14">
						<h1 className="text-4xl font-bold text-textDark">{title}</h1>
					</div>
					<p className="pt-3 text-sm font-medium text-textDark pb-9">
						{message}
					</p>
				</div>
				<Button
					className="w-full max-w-64"
					onClick={
						onSubmit
							? onSubmit
							: () => window.open(getHelpCenterUrl(), "_blank")
					}
				>
					{submitText}
					<ArrowRightIcon className="w-5 h-5" />
				</Button>
			</div>
		</PageTransition>
	);
};

export default ErrorPage;
